import {NgModule} from '@angular/core';

import {HedgingGridComponent} from './hedging-grid.component';
import {
    HgPortfolioPositionsComponent
} from "./positions-section/portfolio-positions/hg-portfolio-positions.component";
import {HgHedgePositionsComponent} from "./positions-section/hedge-positions/hg-hedge-positions.component";
import {HgPositionsSectionComponent} from "./positions-section/hg-positions-section.component";
import {HgSettingsSectionComponent} from "./settings-section/hg-settings-section.component";
import {HgStrategiesSectionComponent} from "./strategies-section/hg-strategies-section.component";
import {DevExtremeModule} from "../devextreme.module";
import {HgPriceboxSectionComponent} from "./pricebox-section/hg-pricebox-section.component";
import {HgZonesGridSectionComponent} from "./zones-grid-section/hg-zones-grid-section.component";
import {CommonModule} from "@angular/common";
import {HedgingGridPanelComponent} from "./hedging-grid-panel.component";
import {HgPortfolioSelectorComponent} from "./positions-section/portfolio-selector/hg-portfolio-selector.component";
import {HgSectionHeaderComponent} from "./section-header/hg-section-header.component";
import {EtsSymbolPickerModule} from "../symbol-picker/symbol-picker.module";
import {OptionsCommonModule} from "../options-common/options-common.module";
import {
    CashFlowStrategyTemplatesService
} from "../adjustment-pricing-grid/services/cashflow-strategy-templates.service";
import {CashFlowPortfoliosService} from "../adjustment-pricing-grid/services/cashflow-portfolios.service";
import {SavedPositionsService} from "../adjustment-pricing-grid/services/saved-positions.service";
import {HedgePositionsService} from "./positions-section/hedge-positions/hedge-positions.service";
import {HgTransactionPopupComponent} from "./transaction-popup/hg-transaction-popup.component";
import {FriendlyDatePipe} from "../common-services/friendly-date.pipe";
import {HgAfterStatePreviewComponent} from "./positions-section/after-state-preview/hg-after-state-preview.component";
import {EtsQtyToMarketSidePipe} from "./market-side.pipe";
import {HgOptionStrategyService} from "./hg-option-strategy.service";
import {ColorPickerModule} from "../color-picker/color-picker.component.module";
import {
    HgZonesGridColumnSelectorComponent
} from "./zones-grid-section/hg-zones-grid-column-selector/hg-zones-grid-column-selector.component";
import {
    HgZonesGridCalculatorComponent
} from "./zones-grid-section/hg-zones-grid-calculator/hg-zones-grid-calculator.component";
import {HgMergeDialogComponent} from "./settings-section/merge-dialog/hg-merge-dialog.component";
import {FriendlyTickerPipe} from "../common-services/friendly-ticker.pipe";
import {LastPriceModule} from "../last-price/last-price.module";
import {
    HgOriginalClientPositionsService
} from "./positions-section/portfolio-selector/hg-original-client-positions.service";
import {EtsCommonModule} from "../common-services/common.module";
import {
    HgHedgePositionsSyncDialogComponent
} from "./positions-section/hedge-positions-sync-dialog/hg-hedge-positions-sync-dialog.component";
import {HgZonesGridMenuComponent} from "./zones-grid-section/hg-zones-grid-menu/hg-zones-grid-menu.component";
import {
    HgZonesGridParametersComponent
} from "./zones-grid-section/hg-zones-grid-parameters/hg-zones-grid-parameters.component";
import {GenericConfirmationDialogModule} from "../generic-confirmation-dialog/generic-confirmation-dialog.module";
import {PositionsStateService} from "../adjustment-pricing-grid/services/positions-before-state.service";
import {ApgDataService} from "../adjustment-pricing-grid/services/apg-data.service";
import {HedgesSortingDialogComponent} from "./settings-section/sorting-dialog/hedges-sorting-dialog.component";
import {OrdersRegroupModule} from "../orders-regroup-dialog/orders-regroup.module";
import {OrdersChainDialogModule} from "../orders-chain-dialog/orders-chain-dialog.module";
import {HgHedgeMatrixComponent} from "./hedge-matrix/hg-hedge-matrix.component";
import {AgGridModule} from "ag-grid-angular";
import {HedgeMatrixDataServiceFactory} from "./hedge-matrix/hedge-matrix-data-service-factory.service";
import {
    HgHedgeMatrixHedgesSelectorComponent
} from "./hedge-matrix/hg-hedge-matrix-hedges-selector/hg-hedge-matrix-hedges-selector.component";
import {HedgeMatrixCustomColumnHeaderGroup} from "./hedge-matrix/hedge-matrix-custom-colgroup-header";
import {SettlementPriceService} from "./settlement-price.service";
import {HgMatrixPunchPadComponent} from "./hedge-matrix/punch-pad/hg-matrix-punch-pad.component";
import {HedgeExpirationCellEditorComponent} from "./hedge-matrix/hedge-expiration-cell-editor.component";
import {MultiExpirationCellRenderer} from "./hedge-matrix/multi-expiration-cell-renderer.component";
import {HedgeMatrixSlideHedgeDialog} from "./hedge-matrix/slide-hedge/slide-hedge-dialog.component";
import {HedgePocketComponent} from "./hedge-matrix/hege-pocket/hedge-pocket.component";
import {OptionsPricingGridModule} from "../options-pricing-grid/options-pricing-grid.module";
import {ExpirationSelectorModule} from "../expiration-selector/expiration-selector.module";
import {HedgeMatrixCustomHeaderComponent} from "./hedge-matrix/custom-header/hedge-matrix-custom-header.component";
import {
    HedgeMatrixTotalCustomHeaderComponent
} from "./hedge-matrix/custom-header/hedge-matrix-total-custom-header.component";
import {PricingStepsPopupComponent} from "./pricing-steps-popup/pricing-steps-popup.component";
import {HgTestingComponent} from "./hg-testing.component";
import {HgTestingService} from "./hg-testing.service";
import {EsFairValueService} from "./services/es-fair-value.service";
import {HgNormalizationService} from "./services/hg-normalization.service";
import {ExpirationPnlCellRenderer} from "./hedge-matrix/expiration-pnl-cell-renderer.component";
import {IvDayOfWeekCellRendererComponent} from "./hedge-matrix/iv-day-of-week-cell-renderer.component";
import {HgUnderlyingPickerComponent} from "./hedge-matrix/underlying-picker/hg-underlying-picker.component";
import {HgCreatePortfolioDialogComponent} from "./positions-section/portfolio-selector/hg-create-portfolio-dialog.component";
import {HgIndependentPortfoliosService} from "./positions-section/portfolio-selector/hg-independent-portfolios.service";
import {HgCopilotComponent} from "./copilot/hg-copilot.component";
import {HgCopilotRiskInputsComponent} from "./copilot/hg-copilot-risk-inputs.component";
import {HgCopilotAdjustTabComponent} from "./copilot/hg-copilot-adjust-tab.component";
import {HgCopilotCloseTabComponent} from "./copilot/hg-copilot-close-tab.component";
import {HgCopilotSolutionCardComponent} from "./copilot/hg-copilot-solution-card.component";
import {HgAvailableAdjustmentsComponent} from "./copilot/hg-available-adjustments.component";
import {HgCopilotCloseAllCardComponent} from "./copilot/hg-copilot-close-all-card.component";
import {HgCopilotInputSummaryComponent} from "./copilot/hg-copilot-input-summary.component";
import {HgCopilotEmptyResultComponent} from "./copilot/hg-copilot-empty-result.component";
import {HgCopilotTransactionsPopupComponent} from "./copilot/hg-copilot-transactions-popup.component";
import {EtsDraggableModule} from "../draggable/ets-draggable.module";
import {EtsFitToViewportModule} from "../fit-to-viewport/ets-fit-to-viewport.module";
import {CopilotSharedModule} from "../copilot-shared/copilot-shared.module";

@NgModule({
    imports: [
        CommonModule,
        EtsCommonModule,
        DevExtremeModule,
        EtsSymbolPickerModule,
        OptionsCommonModule,
        ColorPickerModule,
        LastPriceModule,
        GenericConfirmationDialogModule,
        OrdersRegroupModule,
        OrdersChainDialogModule,
        AgGridModule,
        OptionsPricingGridModule,
        ExpirationSelectorModule,
        EtsDraggableModule,
        EtsFitToViewportModule,
        // The extracted OPG questionnaire components (CR-20260804-001) - the rebuilt Select
        // tab renders them; NgModule imports are not transitive, so the OPG module's own
        // import does not cover this one.
        CopilotSharedModule
    ],
    declarations: [
        HedgingGridPanelComponent,
        HedgingGridComponent,
        HgHedgePositionsComponent,
        HgPortfolioPositionsComponent,
        HgPositionsSectionComponent,
        HgSettingsSectionComponent,
        HgStrategiesSectionComponent,
        HgPriceboxSectionComponent,
        HgZonesGridSectionComponent,
        HgPortfolioSelectorComponent,
        HgSectionHeaderComponent,
        HgTransactionPopupComponent,
        HgAfterStatePreviewComponent,
        EtsQtyToMarketSidePipe,
        HgZonesGridParametersComponent,
        HgZonesGridColumnSelectorComponent,
        HgZonesGridCalculatorComponent,
        HgMergeDialogComponent,
        HgHedgePositionsSyncDialogComponent,
        HgZonesGridMenuComponent,
        HedgesSortingDialogComponent,
        HgHedgeMatrixComponent,
        HgHedgeMatrixHedgesSelectorComponent,
        HedgeMatrixCustomColumnHeaderGroup,
        HgMatrixPunchPadComponent,
        HedgeExpirationCellEditorComponent,
        MultiExpirationCellRenderer,
        HedgeMatrixSlideHedgeDialog,
        HedgePocketComponent,
        HedgeMatrixCustomHeaderComponent,
        HedgeMatrixTotalCustomHeaderComponent,
        PricingStepsPopupComponent,
        ExpirationPnlCellRenderer,
        IvDayOfWeekCellRendererComponent,
        HgUnderlyingPickerComponent,
        HgCreatePortfolioDialogComponent,
        HgCopilotComponent,
        HgCopilotRiskInputsComponent,
        HgCopilotAdjustTabComponent,
        HgCopilotCloseTabComponent,
        HgCopilotSolutionCardComponent,
        HgAvailableAdjustmentsComponent,
        HgCopilotCloseAllCardComponent,
        HgCopilotInputSummaryComponent,
        HgCopilotEmptyResultComponent,
        HgCopilotTransactionsPopupComponent,

        HgTestingComponent
    ],
    exports: [
        HedgingGridPanelComponent,
        HgTransactionPopupComponent,
        EtsQtyToMarketSidePipe,
        HgHedgeMatrixComponent
    ],
    providers: [
        CashFlowStrategyTemplatesService,
        CashFlowPortfoliosService,
        SavedPositionsService,
        HedgePositionsService,
        ApgDataService,
        HgOptionStrategyService,
        HgOriginalClientPositionsService,
        PositionsStateService,
        HedgeMatrixDataServiceFactory,
        SettlementPriceService,
        EsFairValueService,
        HgNormalizationService,
        HgIndependentPortfoliosService,

        HgTestingService
    ],
})
export class HedgingGridModule {
}
